module.exports = __webpack_public_path__ + "img/avatar4.0277397a.png";